import { Dispatch } from "redux";
import UltrarewardAnalyitcService from "service/UltrarewardAnalyitc";
import { showMessage } from "utilities/helper";

export const getTotalAlfamartsMembers = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_MEMBER_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotalAlfamartMembers();

    dispatch({ type: "SET_TOTAL_MEMBER_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_MEMBER", value: data.total_members });
    dispatch({ type: "SET_INCREASE_MEMBER", value: data.increase_member });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_MEMBER_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalRedeem = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotalRedeem();
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({
      type: "SET_CATALOG",
      value: data.catalog,
    });
    dispatch({
      type: "SET_CATALOG_POINT",
      value: data.total_point
    });
    dispatch({
      type: "SET_CATALOG_QTY",
      value: data.total_redeem,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};


export const getTotalCatalogRedeem = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_MEMBER_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotalAlfamartMembers();

    dispatch({ type: "SET_TOTAL_MEMBER_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_MEMBER", value: data.total_members });
    dispatch({ type: "SET_INCREASE_MEMBER", value: data.increase_member });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_MEMBER_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalMembersAlfamart = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotalMembersAlfamart();

    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART", value: data.total_members });
    dispatch({
      type: "SET_INCREASE_MEMBER_ALFAMART",
      value: data.increase_member,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalOcrTempClaimed = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_OCR_TEMP_CLAIMED_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotalOcrTempClaimed();

    dispatch({ type: "SET_TOTAL_OCR_TEMP_CLAIMED_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_OCR_TEMP_CLAIMED", value: data.total_ocrs });
    dispatch({ type: "SET_TOTAL_OCR_TEMP_INCREASE", value: data.increase });
    dispatch({ type: "SET_TOTAL_OCR_TEMP_AMOUNT", value: data.total_amount });
    dispatch({ type: "SET_TOTAL_OCR_TEMP_INCREASE_AMOUNT", value: data.increase_total_amount });
    dispatch({ type: "SET_TOTAL_OCR_POINT_TEMP", value: data.total_point });
    dispatch({ type: "SET_INCREASE_OCR_POINT_TEMP", value: data.increase_point });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_OCR_TEMP_CLAIMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotlOcrAlfamartAmount = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_OCR_AMOUNT_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotlOcrAlfamartAmount();

    dispatch({ type: "SET_TOTAL_OCR_AMOUNT_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_OCR_CLAIMED", value: data.total_point });
    dispatch({type: "SET_TOTAL_OCR_INCREASE",value: data.increase_point});
    dispatch({type: "SET_TOTAL_OCR_ALFAMART",value: data.total_ocrs});
    dispatch({type: "SET_INCREASE_OCR_ALFAMART",value: data.increase_ocrs});
    dispatch({type: "SET_TOTAL_VALUE_ALFAMART",value: data.total_value});
    dispatch({type: "SET_INCREASE_VALUE_ALFAMART",value: data.increase_value});
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_OCR_RAFFLE_AMOUNT_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalUserByCity = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotalUserByCity();

    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: false });
    dispatch({ type: "SET_CITY", value: data.city });
    dispatch({
      type: "SET_CITY_TOTAL_REGISTER",
      value: data.total,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalOcrByCity = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotalOcrByCity();

    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: false });
    dispatch({ type: "SET_OCR_CITY", value: data.ocr_city });
    dispatch({ type: "SET_CITY_TOTAL_OCR", value: data.total_ocr_by_city });
    dispatch({
      type: "SET_CITY_INCREASE_OCR",
      value: data.increase,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};
export const getTotalUserRegistration = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotalUserRegistration();

    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_USER_REGISTRATION", value: data.total_user_registration });
  
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};
export const getTotalOcrPerDay = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: true });
  try {
    const data = await UltrarewardAnalyitcService.getTotalOcrPerDay();

    dispatch({ type: "SET_TOTAL_OCR_PERDAY", value: data.total_ocr });
    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: true });

  
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_MEMBER_ALFAMART_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};
